export default class MainMenu {
    #openStatus = false;

    constructor({
        container = '[data-main-menu="wrapper"]',
        trigger = '[data-main-menu="trigger"]',
        menu = '[data-main-menu="menu"]',
        overlay = '[data-main-menu="overlay"]',
        header = '.header',
        openClass = 'is-open',
        animationClass = 'is-animation',
        bodyClass = 'is-main-menu-open',
        overlayClass = 'active',
        linkSelector = '.main-menu__link',
        homePath = '/',
        scrollClass = 'active',
        scrollOffset = 150,
        onOpen = () => {
        },
        onClose = () => {
        }
    } = {}) {
        this.trigger   = document.querySelector(trigger);
        this.container = document.querySelector(container);
        this.menu      = document.querySelector(menu);
        this.overlay   = document.querySelector(overlay);
        this.header    = document.querySelector(header);

        this.options = {
            openClass,
            animationClass,
            bodyClass,
            overlayClass,
            linkSelector,
            homePath,
            scrollClass,
            scrollOffset,
            onOpen,
            onClose
        };

        this._init();
        this._initScrollHandler();
    }

    get openStatus() {
        return this.#openStatus;
    }

    _init() {
        const {
            linkSelector,
            homePath
        } = this.options;

        if (this.trigger && this.container) {
            this.trigger.addEventListener('click', this._click.bind(this));
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', (e) => {
                if (e.target === this.overlay && this.#openStatus) {
                    this._close();
                }
            });
        }

        if (this.menu) {
            const navLinks = this.menu.querySelectorAll(linkSelector);
            navLinks.forEach((link) => {
                link.addEventListener('click', (e) => {
                    const href = link.getAttribute('href');

                    if (this.#openStatus) this._close();

                    if (href && href.startsWith('#')) {
                        e.preventDefault();

                        const target = document.querySelector(href);

                        if (window.location.pathname === homePath && target) {
                            setTimeout(() => {
                                target.scrollIntoView({
                                    behavior : 'smooth',
                                    block    : 'start'
                                });
                            }, 300);
                        } else {
                            setTimeout(() => {
                                window.location.href = homePath + href;
                            }, 300);
                        }
                    }
                });
            });
        }
    }

    _initScrollHandler() {
        this._handleScroll = this._handleScroll.bind(this);
        window.addEventListener('scroll', this._handleScroll);

        this._handleScroll();
    }

    _handleScroll() {
        const {
            scrollClass,
            scrollOffset
        } = this.options;

        if (!this.header) return;

        const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

        if (scrollY > scrollOffset) {
            if (!this.header.classList.contains(scrollClass)) {
                this.header.classList.add(scrollClass);
            }
        } else if (this.header.classList.contains(scrollClass)) {
            this.header.classList.remove(scrollClass);
        }
    }

    destroy() {
        window.removeEventListener('scroll', this._handleScroll);
    }

    _click(e) {
        e.preventDefault();
        if (!this.#openStatus) {
            this._open();
        } else {
            this._close();
        }
    }

    _open() {
        const {
            openClass,
            animationClass,
            bodyClass,
            overlayClass,
            onOpen
        } = this.options;

        this.#openStatus = true;

        this.trigger.classList.add(openClass);
        this.trigger.setAttribute('aria-label', 'Закрыть меню');

        document.body.classList.add(bodyClass);

        this.container.classList.add(openClass, animationClass);

        if (this.overlay) this.overlay.classList.add(overlayClass);

        setTimeout(() => {
            this.menu.classList.add(animationClass);
        }, 50);

        if (onOpen) onOpen();
    }

    _close() {
        const {
            openClass,
            animationClass,
            bodyClass,
            overlayClass,
            onClose
        } = this.options;

        this.menu.classList.remove(animationClass);
        this.container.classList.remove(animationClass);
        this.trigger.classList.remove(openClass);
        this.trigger.setAttribute('aria-label', 'Открыть меню');

        if (this.overlay) this.overlay.classList.remove(overlayClass);

        const animationDuration = 300;
        setTimeout(() => {
            this.container.classList.remove(openClass);
            document.body.classList.remove(bodyClass);
            this.#openStatus = false;

            if (onClose) onClose();
        }, animationDuration);
    }

    closeMainMenu() {
        if (this.#openStatus) this._close();
    }
}
